import { useState } from 'react';
import { toast } from 'react-toastify';
import { useLoaderStore } from '../../../stores/loader.store';
import { ConfirmationModal } from '../../../shared/components/Modal/ConfirmationModal';
import cloudUpload from "../../../assets/Images/cloud-upload.png";
import thankYouService from '../../../Services/thank-you.service';

export function ReleaseDraftThankYou({ draftThankyou, onReleaseSuccess }) {
    const setShowLoader = useLoaderStore((state) => state.setShowLoader);
    const [message, setMessage] = useState(draftThankyou.description);
    const [fromFirstname, setFromFirstname] = useState(draftThankyou.createdUserData.firstName);
    const [staffFirstname, setStaffFirstname] = useState(draftThankyou.type != 'team' ? draftThankyou?.users[0].firstName : draftThankyou?.teams[0].name);
    const [showConfirmation, setShowConfirmation] = useState(false);

    async function handleReleaseMessage() {
        setShowLoader(true);

        let data = {
            draftThankyouId: draftThankyou._id,
            fromFirstName: fromFirstname,
            message: message
        };

        try {
            const res = await thankYouService.releaseDraftThankyou(data);
            if (res.status === 200) {
                toast.success("Successfully released draft thankyou");
                onReleaseSuccess();
                return;
            }

            toast.error("Couldn't release thankyou");
        } catch (err) {
            console.log(err);
            toast.error("Couldn't release thankyou");
        } finally {
            setShowLoader(false);
        }
    }

    return (
        <div style={{ minWidth: '600px', maxWidth: '1000px', maxHeight: '1000px', overflowY: "auto" }} className='p-2'>
            <div className="mb-2">
                <div className="mb-2">
                    <label className="cstm-label">To {draftThankyou.type != 'team' ? 'Firstname' : 'Team'}</label>
                    <input
                        disabled={true}
                        type="text"
                        class="cstm-input"
                        value={staffFirstname}
                        // onChange={(e) => setStaffFirstname(e.target.value)}
                    />
                </div>
                <div className="mb-2">
                    <label className="cstm-label">From</label>
                    <input
                        type="text"
                        class="cstm-input"
                        value={fromFirstname}
                        onChange={(e) => setFromFirstname(e.target.value)}
                    />
                </div>
                <div className="mb-2">
                    <label className="cstm-label">Edit Message (Optional)</label>
                    <textarea
                        type="text"
                        className="cstm-input-moderation-field"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end">
                <button type='button' className='cstm-submitbutton' onClick={() => setShowConfirmation(true)}>Release</button>
            </div>

            {showConfirmation &&
                <ConfirmationModal
                    text='Are you sure you want to release this thank you message?'
                    confirmBtnText='Release'
                    imgSrc={cloudUpload}
                    onConfirm={handleReleaseMessage}
                    onCancel={() => setShowConfirmation(false)}
                />}
        </div>
    );
}